import React, { Component } from "react";
import Loader from "./Loader";
import moment from "moment";
import loginService from "../services/login.service";
import { showMessage } from '../helpers/helper';

export default class LoginDoisFatores extends Component {
    section_id = window.crypto.randomUUID();
    constructor(props) {
        super(props);
        this.state = {
            two_factor_envio_atual: (this.props.two_factor_device.startsWith("mobile") ? 'celular' : 'e-mail'),
            timeRemaining: this.getTimeRemaining(this.props.two_factor_expiration),
            reenviarDisponivelEm: this.props.two_factor_tempo_espera_reenvio ?? 60,            
        };
    }    

    interval;
    componentDidMount() {
        this.inicializaTimer();
        setTimeout(() => { this.getInputs().at(0).focus() }, 600);
    }

    inicializaTimer() {
        this.interval = window.setInterval(() => {
            this.setState(prevState => ({
                timeRemaining: this.getTimeRemaining(this.props.two_factor_expiration),
                reenviarDisponivelEm: Math.max(prevState.reenviarDisponivelEm - 1, 0),
            }));
        }, 1000);
    }


    removeTimer() {

        try {
            window.clearInterval(this.interval);
        } catch { }
    }

    componentWillUnmount() {
        this.removeTimer();
    }

    componentDidUpdate() {
        if (this.state.timeRemaining.asSeconds() < 0) this.props.onExpired();
    }

    getTimeRemaining(expiration) {
        const diff = moment(expiration).diff(moment(), "seconds");
        const duration = moment.duration(diff, "seconds");

        return duration;
    }

    timeRemainingToString() {
        const diff = this.state.timeRemaining;
        return diff.minutes().toString().padStart(2, "0") + ":" + diff.seconds().toString().padStart(2, "0");
    }

    getInputs = () => {
        const inputs = [...document.querySelectorAll(".two_factor_input")];
        return inputs;
    };

    handleChangeInput = (e) => {
        const inputs = this.getInputs();
        e.target.value = (e.target.value || "").replaceAll(/[^0-9]/g, "");

        const value = [...inputs]
            .map((x) => x.value || "")
            .join("")
            .replaceAll(/[^0-9]/g, "");

        if (value.length < this.props.two_factor_size) {
            const next = inputs.find((x) => !x.value);
            console.log({ next });
            next.focus();

            return;
        }

        this.handleVerification(value);
    };

    sending = false;
    handleVerification = async (code) => {
        if (this.sending) return;
        this.sending = true;
        try {
            this.removeTimer();

            this.setState({ loading: true });
            const response = await loginService.autenticarDoisFatores({ key: code, prefix: this.props.two_factor_prefix });
            const result = response?.data;

            if (result?.success) {
                localStorage.setItem("token", result.token);
                if (result.user)
                    localStorage.setItem("user", result.user);
                this.props.onSucess({
                    alterar_senha: !!result?.alterar_senha,
                    user: result.user,
                    token: result.token,
                    portal: result.portal,
                });
                return;
            }

            this.getInputs().forEach((x) => (x.value = ""));
            window.setTimeout(() => {
                this.getInputs().at(0).focus();
            }, 600);
            this.section_id = crypto.randomUUID();
            const message = result?.message ?? "Ocorreu um erro ao autenticar a chave. Tente novamente mais tarde ";

            this.setState({
                error: message,
            });

        } finally {
            this.setState({
                loading: false,
            });
            this.sending = false;
            this.inicializaTimer();
        }
    };

    handleKeyDown = (e) => {
        e.target.value = "";
    };

    reenviar = async (tipo) => {

        this.setState({
            loading: true,
            two_factor_envio_atual: (tipo === 0 ? 'celular' : 'e-mail'),
        });

        try {
            const result = await loginService.reenviarDoisFatores({ prefix: this.props.two_factor_prefix, tipo });
            if (!result.data.success) {
                showMessage("Não foi possível reenviar o token")
                return;
            }

            this.props.onTokenUpdate({
                ...result.data
            });
            this.setState({
                timeRemaining: this.getTimeRemaining(result.data.two_factor_expiration),
                reenviarDisponivelEm: this.props.two_factor_tempo_espera_reenvio ?? 60,
                error: undefined
            });

        } finally {
            this.setState({ loading: false })
        }
    }

    render() {
        const inputs = Array.from({ length: this.props.two_factor_size }, (_, i) => ({ id: i }));

        return (
            <>
                <Loader isLoading={this.state.loading} />
                <div className="two-factor-container" data-hidden={this.state.loading}>
                    <h5 style={{ textTransform: "uppercase" }}>
                        DIGITE ABAIXO O NÚMERO QUE RECEBEU NO SEU <b>{this.state.two_factor_envio_atual}</b>
                    </h5>
                    <section className="inputs-section" id={this.section_id} data-shake={!!this.state.error}>
                        {inputs.map((input) => (
                            <input
                                maxLength={1}
                                data-id={input.id}
                                onChange={this.handleChangeInput}
                                onKeyDown={this.handleKeyDown}
                                className="two_factor_input"
                                key={input.id}
                            ></input>
                        ))}
                        <span
                            style={{
                                color: this.state.timeRemaining.asSeconds() < 30 ? "red" : "black",
                            }}
                        >
                            {this.timeRemainingToString()}
                        </span>
                    </section>
                    {(this.props.two_factor_device === "mobile_email" || this.props.two_factor_device === "mobile") && (
                        <a
                            style={{ cursor: this.state.reenviarDisponivelEm === 0 ? "pointer" : "not-allowed", color: this.state.reenviarDisponivelEm === 0 ? "" : "gray" }}
                            onClick={this.state.reenviarDisponivelEm === 0 ? () => this.reenviar(0) : undefined}
                        >
                            Reenviar por SMS: {this.props.two_factor_celular}
                            {this.state.reenviarDisponivelEm > 0 && ` (disponível em ${this.state.reenviarDisponivelEm}s)`}
                        </a>
                    )}

                    {(this.props.two_factor_device === "mobile_email" || this.props.two_factor_device === "email") && (
                        <a
                            style={{ cursor: this.state.reenviarDisponivelEm === 0 ? "pointer" : "not-allowed", color: this.state.reenviarDisponivelEm === 0 ? "" : "gray" }}
                            onClick={this.state.reenviarDisponivelEm === 0 ? () => this.reenviar(3) : undefined}
                        >
                            Reenviar por e-mail: {this.props.two_factor_email}
                            {this.state.reenviarDisponivelEm > 0 && ` (disponível em ${this.state.reenviarDisponivelEm}s)`}
                        </a>
                    )}

                    <p style={{ color: "red", textTransform: "lowercase" }}>{this.state.error}</p>
                </div>
            </>
        );
    }
}
